export default "__VITE_ASSET__BF$h1buv__"